<template>
  <router-link
    v-slot="{ href, isActive, navigate, isExactActive }"
    :to="to"
    class="LKAsideMenuItem"
    custom
  >
    <a
      :href="href"
      :class="{
        'w--current': isActive || isExactActive,
        'is-active': isActive || isExactActive,
        'is-disabled': disabled,
      }"
      class="aside__link w-inline-block"
      @click="navigate"
    >
      <v-badge
        :value="newCount > 0"
        :content="newCount"
        :color="color"
        inline
        overlap
      >
        <div class="text-lg-bold mod--aside" v-text="label" />
      </v-badge>

      <div class="aside__link-number">
        <div v-if="!loading" class="text-sm" v-text="countNumber" />
        <v-progress-circular
          v-else
          indeterminate
          color="#4a759d"
          size="24"
          width="2"
        />
      </div>
    </a>
  </router-link>
</template>

<script>
import variables from '@/assets/scss/exports.scss'

export default {
  name: 'LKAsideMenuItem',
  props: {
    to: {
      type: [String, Object],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    children: {
      type: Array,
    },
    newCount: Number,
    loading: Boolean,
    disabled: Boolean,
  },
  data: () => ({
    color: variables['webflow-color-blue'],
  }),
  computed: {
    countNumber() {
      if (this.count <= 0) {
        return '-'
      }
      return this.count
    },
  },
}
</script>

<style lang="scss">
.LKAsideMenuItem {
  &.is-active {
    background-color: $webflow-color-blue-shadow;
    border-left: 3px solid $webflow-color-blue-dark;
  }

  .v-badge {
    width: 100%;
    margin-right: 8px;

    .mod--aside {
      width: 100%;
    }
  }

  &.is-disabled {
    pointer-events: none;

    .text-lg-bold {
      opacity: 0.5;
    }
  }
}
</style>
